import { Button, styled as muiStyled, Stack, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import hapLogoblue from '@assets/images/blueLogo.png';

import type { ServiceItemCardProps } from './types';

const SectionTitle = muiStyled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: 600,
  lineHeight: '100%',
}));

const CardTitle = muiStyled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '100%',
  textAlign: 'left',
}));

const CardDescription = muiStyled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '100%',
  textAlign: 'left',
}));

const TextBox = muiStyled(Stack)(() => ({
  padding: '12px 0',
  gap: '4px',
  maxWidth: '315px',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
}));

const IconBox = muiStyled(Stack)(() => ({
  height: '32px',
  width: '32px',
  borderRadius: '50%',
  backgroundColor: NEW_COLORS.SECONDARY[50],
}));

const ServiceItemCard = muiStyled(Button, {
  shouldForwardProp: prop => prop !== 'primary',
})<ServiceItemCardProps>(({ primary }) => ({
  background: primary ? NEW_COLORS.PRIMARY[50] : NEW_COLORS.BASE.WHITE,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  flexDirection: 'column',
  width: '100%',
  borderRadius: '8px',
  padding: primary ? '16px 16px 16px 24px' : '12px 16px',
  position: 'relative',
  minHeight: '84px',
  overflow: 'hidden',

  ...(primary && {
    '::after': {
      content: '""',
      position: 'absolute',
      right: '60px',
      top: '65%',
      transform: 'translateY(-50%)',
      width: '120px',
      height: '120px',
      backgroundImage: `url('${hapLogoblue}')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  }),
}));

export {
  ServiceItemCard,
  SectionTitle,
  IconBox,
  TextBox,
  CardTitle,
  CardDescription,
};
